import React from 'react';
import SelectableMinimalCard from '../../../../shared/SelectableMinimalCard';
import Text from '../../../../v2BaseComponents/Text';

export type SuggestedFolderCardOwnProps = {
    title: string;
    isSelectable: true;
    isSelected: boolean;
    onSelect: () => void;
    isDisabled?: boolean;
};

export type SuggestedFolderCardProps = SuggestedFolderCardOwnProps;

const SuggestedFolderCard: React.FC<SuggestedFolderCardProps> = (props) => (
    <SelectableMinimalCard {...props} testID={`suggested-folder-${props.title}`}>
        <Text variant="bold-body-1">{props.title}</Text>
    </SelectableMinimalCard>
);

export default React.memo(SuggestedFolderCard);
